import React from "react";
import { Bird } from "lucide-react";

const StartScreen = ({ highScore, onStart }) => {
  return (
    <div className="start-screen">
      <h1>FlappyTrade</h1>
      <Bird size={48} className="game-bird-icon" />
      <p>High Score: {highScore}</p>
      <button onClick={onStart}>Start Game</button>
      <div className="instructions">
        <p>Click or Press Space to Jump</p>
        <p>Avoid the Candlesticks!</p>
      </div>
    </div>
  );
};

export default StartScreen;
